<template>
  <img
    :src="iconSrc"
    :alt="alt"
    class="library-icon"
    :class="`library-icon--${library}`"
  />
</template>

<script>
const LIBRARY_ICON_PATHS = Object.freeze({
  conti: "/menu/Icona Libreria Codici Conto.png",
  tributi: "/menu/Icona Libreria Codici Tributo.png",
  bilanci: "/menu/Icona Libreria Bilanci Analitici.png",
});

export default {
  name: "LibraryIcon",
  props: {
    library: {
      type: String,
      required: true,
      validator: (value) =>
        Object.prototype.hasOwnProperty.call(LIBRARY_ICON_PATHS, value),
    },
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    iconSrc() {
      return LIBRARY_ICON_PATHS[this.library];
    },
  },
};
</script>

<style scoped>
.library-icon {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
